import * as React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { AppContextProvider, PaymentContextProvider } from './context';
import CustomRouter from './CustomRouter';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <CustomRouter history={history}><AppContextProvider>
        <PaymentContextProvider>
            <App  history={history}/>
        </PaymentContextProvider>
    </AppContextProvider></CustomRouter>);
